<template>
  <div id="app">
    <!-- Mostrar el menú lateral solo si aplica -->
    <SideMenu v-if="mostrarMenuLateral && role === 'administrador'" />
    <MenuEmpleado v-else-if="mostrarMenuLateral && role === 'empleado'" />
    <router-view />
  </div>
</template>

<script>
import { computed, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import SideMenu from "./components/SideMenu.vue";
import MenuEmpleado from "./components/MenuEmpleado.vue";

export default {
  components: {
    SideMenu,
    MenuEmpleado,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();

    const role = ref(localStorage.getItem("role") || null);

    const mostrarMenuLateral = computed(() => {
      if (!route || !route.path) return false; // Verifica que route esté disponible
      const rutasConMenu = ["/Admin", "/Empleado"];
      return rutasConMenu.some((ruta) => route.path.startsWith(ruta)) && !!role.value;
    });

    onMounted(() => {
      if (!role.value) {
        router.push("/"); // Redirige al inicio si no hay un rol definido
      }
    });

    return {
      mostrarMenuLateral,
      role,
    };
  },
};
</script>